<template>
  <div class="box-container">
    <d-header
      :actions="[
        {
          label: $t('new_owner_business'),
          resource: 'ownerBusiness',
          path: 'owner-businesses/create',
          primary: true,
          color: 'is-primary',
        },
      ]"
      fluid
      :breadcrumbs="false"
      :class="{
        'pt-5': $laravel.user.is_owner_contact || $laravel.user.owner_id,
      }"
    >
      <h2 class="title is-4">
        {{ $t("owner_businesses") }}
      </h2>
    </d-header>

    <v-owner-business-list :owner_id="model.id" />
  </div>
</template>

<script>
import list from "./_list.vue";

export default {
  components: {
    "v-owner-business-list": list,
  },
  props: {
    model: {
      default: null,
      type: Object,
    },
  },
  metaInfo() {
    return {
      title: this.$t("owner_businesses").capitalize(),
    };
  },
};
</script>
